import React from 'react'
import { Users, Gift, TrendingUp, Star, MessageCircle } from 'lucide-react'

export const ReferralStatsCards = ({ referralStats }) => {
  const successRate = (referralStats?.total_referrals || 0) > 0 
    ? Math.round(((referralStats?.completed_referrals || 0) / referralStats.total_referrals) * 100) 
    : 0

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center">
            <Users className="w-6 h-6 text-teal-600" />
          </div>
          <TrendingUp className="w-5 h-5 text-green-500" />
        </div>
        <div className="space-y-2">
          <p className="text-3xl font-bold text-gray-900">{referralStats?.total_referrals || 0}</p>
          <p className="text-sm text-gray-600">Total Referrals</p>
          <div className="flex items-center gap-4 text-xs">
            <span className="text-green-600 font-medium">
              {referralStats?.completed_referrals || 0} Completed
            </span>
            <span className="text-amber-600 font-medium">
              {referralStats?.pending_referrals || 0} Pending
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
            <Gift className="w-6 h-6 text-green-600" />
          </div>
          <Star className="w-5 h-5 text-yellow-500" />
        </div>
        <div className="space-y-2">
          <p className="text-3xl font-bold text-gray-900">AED {referralStats?.total_rewards_earned || 0}</p>
          <p className="text-sm text-gray-600">Total Earned</p>
          <div className="flex items-center gap-4 text-xs">
            <span className="text-green-600 font-medium">
              AED {referralStats?.paid_rewards || 0} Paid
            </span>
            <span className="text-amber-600 font-medium">
              AED {referralStats?.pending_rewards || 0} Pending
            </span>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
            <TrendingUp className="w-6 h-6 text-blue-600" />
          </div>
          <MessageCircle className="w-5 h-5 text-blue-500" />
        </div>
        <div className="space-y-2">
          <p className="text-3xl font-bold text-gray-900">{successRate}%</p>
          <p className="text-sm text-gray-600">Success Rate</p>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div 
              className="bg-blue-500 h-2 rounded-full transition-all duration-300"
              style={{ width: `${successRate}%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}